import React, { FC } from 'react';

import {
  Flex,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import SiteMultiSelect from 'components/primitives/SiteMultiSelect';
import FormikSelectInput from 'components/primitives/FormikSelectInput';
import FormikImageInput from '../FormikImageInput';

import getSortedData from 'utils/getSortedData';

import { initialValues, validationSchema } from './AddGroupModal.utils';

import { AddGroupModalViewProps } from './AddGroupModal.props';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const TYPE = ['Site Owner', 'Concessionaire'];

const AddGroupModalView: FC<AddGroupModalViewProps> = (props) => {
  const { isOpen, onClose, onCreate, isCreating, groupId } = props;
  return (
    <Modal
      size="xl"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="20px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader color="support.500" textAlign="center">
          Add Group
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" p={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onCreate}>
              {({ isValid, values }) => (
                <Form>
                  <Flex gap="20px" direction="column">
                    <FormikInput
                      name="companyName"
                      label="Group Name"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <FormikSelectInput
                      placeholder="Select a Type"
                      label="Type"
                      name="type">
                      {getSortedData(TYPE)?.map((s) => (
                        <option key={s} value={s}>
                          {s || ''}
                        </option>
                      ))}
                    </FormikSelectInput>
                    {/* <FormikInput
                      name="billingContact"
                      label="Billing Contact"
                      labelProps={labelProps}
                      containerProps={{ flex: 1 }}
                    /> */}
                  </Flex>
                  <SiteMultiSelect values={values.sites} />
                  <Flex my={12} flexDirection="row" justifyContent="center">
                    <Button
                      variant="outline"
                      marginRight="10px"
                      isDisabled={isCreating}
                      w="134px"
                      onClick={onClose}>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      isLoading={isCreating}
                      isDisabled={!isValid}
                      w="134px">
                      Create
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddGroupModalView;
